/* eslint-disable no-console */
// React and related imports
import React, { useMemo, useState } from 'react';

// i18 hooks
import { useTranslation } from 'react-i18next';

// Flowbite components
import { Table } from 'flowbite-react';

// Types & Interfaces
import { IContent } from '../../common/interfaces/Content.interface';
import { ContentContextTypes } from '../../common/enums/ContentContextTypes';

// Custom Components
import { ContentTableHead } from './ContentTableHead';
import { ContentTableBody } from './ContentTableBody';

// Utils
import { SortableKeys, sortItems } from '../../utils/sortItems';

interface IContentTableProps {
  contents: IContent[];
  contextType: ContentContextTypes;
}

export const ContentTable: React.FC<IContentTableProps> = ({
  contents,
  contextType,
}) => {
  const { t } = useTranslation();

  const [sortBy, setSortBy] = useState<string>('');
  const [ascending, setAscending] = useState(true);

  const handleSort = (field: string) => {
    if (sortBy === field) {
      setAscending(!ascending); // Toggle if same field clicked again
    } else {
      setSortBy(field);
      setAscending(true); // Reset to ascending when switching fields
    }
  };

  const sortedItems = useMemo(() => {
    return sortItems(contents ?? [], sortBy as SortableKeys, ascending);
  }, [contents, sortBy, ascending]);

  return (
    <div className="w-full max-w-full overflow-x-auto">
      <Table id="pagination-table">
        <ContentTableHead sortingHandler={handleSort} />
        <ContentTableBody
          t={t}
          tableData={sortedItems}
          contextType={contextType}
        />
      </Table>
    </div>
  );
};
